export * from './UTILSPromoCard';
